<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
        <p class="mt-4">Loading your dashboard...</p>
        <div style="margin-top: 12px;">
          <a href="http://www.27pub.com/vt" target="_blank" rel="noopener" style="font-size:1rem; color:#1976d2; text-decoration:underline;">
            To view a tournament, click here
          </a>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router'; 
import { useUserStore } from '@/stores/users';

const userStore = useUserStore();
const router = useRouter();

onMounted(() => {
  // The userStore is now populated by the router guard (`checkLogin`)
  // so we can just read the permissions and redirect.
  if (userStore.user ) {
    const permissions = userStore.user.permissions; // Now this is safe to access
    if (userStore.user.permissions.admin) {
      router.push({ name: 'AdminView' }); // Admins go to the admin dashboard
    } else if (permissions.poker === 'approved') {
      router.push({ name: 'SessionEntry' });
    } else if (permissions.tournament === 'approved') {
      router.push({ name: 'TournamentView' });
    } else {
      router.push({ name: 'PendingView' });
    }
  } else {
    // This should not happen if the route is guarded, but as a fallback...
    router.push({ name: 'UserLogin' });
  }
});
</script>
